import React from 'react';

import { Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import IconRow from '../IconRow';

import { iconGroupStackStyles } from './IconGroup.styles';

const IconGroup = ({ label, rows }) => (
  <Stack sx={iconGroupStackStyles}>
    <Typography color="text.secondary" variant="regular14">
      {label}
    </Typography>
    {rows.map(({ id, icon, value, isModified, authors, fieldLabel }) => (
      <IconRow
        authors={authors}
        fieldLabel={fieldLabel}
        icon={icon}
        isModified={isModified}
        key={id}
        value={value}
      />
    ))}
  </Stack>
);

IconGroup.propTypes = {
  label: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.elementType.isRequired,
      id: PropTypes.string.isRequired,
      authors: PropTypes.arrayOf(PropTypes.object),
      fieldLabel: PropTypes.string,
      isModified: PropTypes.bool,
      value: PropTypes.node,
    }),
  ).isRequired,
};

export default IconGroup;
